import React, { useEffect, useState } from 'react';



import { urlWebsite } from '../../../../../../../config';

import ParagraphDangerous from '../../../../../../../components/UIComponents/ParagraphDangerous';

import { useModal } from '../../../../../../../hooks/Modal';
import { FaClock } from 'react-icons/fa';
import { date, hour, simpleDateBR, simpleDateUS } from 'src/utils/date';
import { useLanguage } from 'src/hooks/Language';
import { ParagraphUI } from 'src/components/UIComponents/Paragraph/styles';
import { Line } from './styles';

interface IProps {
    list: Record<string, any>;
}

const ProgramWidget: React.FC<IProps> = ({ list }) => {

    const { language } = useLanguage();
    const [items, setItems] = useState<JSX.Element[]>([])

    const [program, setProgram] = useState([]);
    const [roomFilters, setRoomFilters] = useState<Record<string, any>[]>([]);
     const [categoryFilters, setCategoryFilters] = useState<Record<string, any>[]>([]);
    const [filters, setFilters] = useState<Record<string, any>[]>([]);
    const [filter, setFilter] = useState('');
    const [roomFilter, setRoomFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');


      const applyCategoryFilter = (value, current) => {
        if (current === value) {
            setCategoryFilter('');
        }
        else {
            setCategoryFilter(value)
        }

        window?.scrollTo(0, 0)
    }

    const applyFilter = (value, current) => {
        if (current === value) {
            setFilter('');
        }
        else {
            setFilter(value)
        }

        window?.scrollTo(0, 0)
    }

    const applyRoomFilter = (value, current) => {
         
        if (current === value) {
            setRoomFilter('');
        }
        else {
            setRoomFilter(value)
        }

        window?.scrollTo(0, 0)
    }

    useEffect(() => {

        const filtersList: Record<string, any>[] = [];
        const roomFiltersList: Record<string, any>[] = [];

        const categoryFiltersList: Record<string, any>[] = [];
        {
            list?.map(
                (line) => {
                    line?.program?.map(block => {

                        const dateInfo = simpleDateBR(block?.start_at);
                        const dateInfoUS = simpleDateUS(block?.start_at);

                        const index = filtersList?.findIndex(i => i?.date === dateInfoUS);

                        if (index < 0) {
                            filtersList.push({ title: dateInfo, title_en: dateInfoUS, title_es: dateInfo, date: dateInfoUS });
                        }
 
                        if (line?.room) {
                            const indexRoom = roomFiltersList?.findIndex(i => i === line?.room);
                            if (indexRoom < 0) {
                                roomFiltersList.push(  line?.room )
                            }
                        }

                             if (line?.category) {
                            const indexRoom = categoryFiltersList?.findIndex(i => i?.category === line?.category);
                            if (indexRoom < 0) {
                                categoryFiltersList.push({ category: line?.category })
                            }
                        }
                    })


                })
        }
        setFilters(filtersList)
        setRoomFilters(roomFiltersList)
setCategoryFilters(categoryFiltersList)


    }, [ list])

    const reduceList = (listItems, dateFilter, roomFilterValue) => {
 
        const items: Record<string, any>[] = [];

        listItems.map(line => {


            const count = line?.program?.filter(i => {
                const date = simpleDateUS(i?.start_at);

                if (roomFilterValue && dateFilter) {

                    return date === dateFilter && line?.room === roomFilterValue;
                }
                else if (dateFilter) {
                    return date === dateFilter;
                }
                else if (roomFilterValue) {
                    return line?.room === roomFilterValue;
                }

                return false;
            })?.length;

            if (count > 0) {
                items?.push(line);
            }

        })


        return items;


    }

    const completeListDate = !filter && !roomFilter ? list : reduceList(list, filter, '');
    const completeList = !filter && !roomFilter ? list : reduceList(list, filter, roomFilter);
 
    const rooms =  !filter  ? roomFilters : completeListDate?.reduce((prev,item) => {


        if(!item?.room){
            return prev;
        }

        const index = prev.findIndex( i => i?.room === item?.room);

        if(index < 0){
            prev.push(item?.room)
        }


        return prev;


    },[])


     
 
    return (<>



        <div className='full-width column gap' style={{ width: '100%', padding: '0px', }}>
            <div className='row-start gap-sm full-width' style={{flexWrap:'wrap', paddingBottom: '15px', borderBottom: '2px solid #fff', }}>
                {filters?.map(
                    (line) => {
                        return <button onClick={() => {applyFilter(line?.title_en, filter); applyRoomFilter('',roomFilter)}} className={filter === line?.title ? 'greenButton2' : 'greenButton2'} style={{ width: 'max-content',
                            color: filter === line?.title_en ? '#fff' : '#162743',
                            background: filter === line?.title_en ? '#162743' : '#fff'

                        }}>{line?.[`title_${language}`] ? line?.[`title_${language}`] : line?.title}</button>
                    })}


            </div>
            <div className='row-start gap-sm full-width' style={{flexWrap:'wrap', paddingBottom: '15px', borderBottom: '2px solid #fff', }}>
                {rooms?.map(
                    (line) => {
                        return <button onClick={() => applyRoomFilter(line, roomFilter)} className={roomFilter === line ? 'greenButton2' : 'greenButton2'} style={{width: 'max-content',
                            color: roomFilter === line ? '#fff' : '#162743',
                            background: roomFilter === line ? '#162743' : '#fff'

                        }}>{line?.[`room_${language}`] ? line?.[`room_${language}`] : line}</button>
                    })}


            </div>

    {/*  <div className='row-start gap-sm full-width' style={{flexWrap:'wrap', paddingBottom: '15px', borderBottom: '2px solid #fff', }}>
                {categoryFilters?.map(
                    (line) => {
                        return <button onClick={() => applyCategoryFilter(line?.category, categoryFilter)} className={categoryFilter === line?.category ? 'greenButton2' : 'greenButton2'} style={{width: 'max-content',
                            color: roomFilter === line?.room ? '#fff' : '#162743',
                            background: roomFilter === line?.room ? '#162743' : '#fff'

                        }}>{line?.[`category_${language}`] ? line?.[`category_${language}`] : line?.category}</button>
                    })}


            </div> */}
            

            {completeList?.map(
                (line: Record<string, any>) => {


                    return <div className='column-start full-width'>
                        {line?.title ? <h2>{line?.title}</h2> : <></>}
                        {line?.description ? <ParagraphUI  color='#fff' dangerouslySetInnerHTML={{ __html: line?.description }} /> : <></>}
                        {line?.type === 'line' ? <div className='column-start gap-sm' style={{ paddingTop: '15px' }}>
                            {line?.program?.map((block: Record<string, any>) => <div className='column-start'>
                                {block?.start_at ? <div className='row-start' style={{ gap: '5px', padding: '10px 0px' }}><FaClock style={{ fontSize: '18px' }} /> {hour(block?.start_at, language)} {block?.end_at ? ` - ${hour(block?.end_at, language)}` : <></>} </div> : <></>}
                                {block?.image ? <img src={`${urlWebsite}/${block?.image}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}



                                {block?.rows?.map((item) => {
                                    return <div className='row' style={{ background: 'none', padding: '10px 0px', gap: '5px', alignItems: 'center', justifyContent: 'flex-start' }}>
                                        {item?.image ? <img src={`${urlWebsite}/${item?.image}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}
                                        {item?.title ? <p dangerouslySetInnerHTML={{ __html: item?.title }} /> : <></>}
                                        {item?.image2 ? <img src={`${urlWebsite}/${item?.image2}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}

                                    </div>

                                })}

                            </div>)}
                        </div> : <></>}


                        {line?.type === 'table' || !line?.type ? <table className='tableRef2' style={{ width: '100%', paddingTop: '15px', marginTop: '15px' }}>
                            <tbody>
                                {line?.program?.map((block: Record<string, any>) => {

                                    return <Line background={block?.background} color={block?.color}>

                                        {block?.start_at || block?.end_at || block?.image ? <td style={{ minWidth: '150px', width: '150px' }}>

                                            {block?.start_at ? <div className='row-start' style={{ gap: '5px', padding: '10px 0px' }}><FaClock style={{ fontSize: '18px', minWidth: '20px' }} /> {hour(block?.start_at, language)} {block?.end_at ? ` - ${hour(block?.end_at, language)}` : <></>} </div> : <></>}
                                            {block?.image ? <div className='full-width column'><img src={`${urlWebsite}/${block?.image}`} style={{ minWidth: '60px', margin: '0px auto', width: '60px' }} /></div> : <></>}

                                        </td> : <></>}

                                        <td colSpan={block?.start_at || block?.end_at || block?.image ? 1 : 2}>

                                            {block?.rows?.map((item) => {
                                                return <div className='row' style={{ background: 'none', padding: '10px 0px', gap: '5px', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                    {item?.image ? <img src={`${urlWebsite}/${item?.image}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}
                                                    {item?.title ? <p dangerouslySetInnerHTML={{ __html: item?.title }} /> : <></>}
                                                    {item?.image2 ? <img src={`${urlWebsite}/${item?.image2}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}

                                                </div>

                                            })}

                                        </td>


                                    </Line>

                                })}

                            </tbody>


                        </table> : <></>}

                    </div>

                }

            )}





        </div>

    </>);
};
export default ProgramWidget;
